import { privateRequest } from "../axios";

const ENDPOINT = {
    GET_ALL_CHALLENGES: '/challenge',
    GET_CHALLENGE_BY_ID: '/challenge/:id',
    CREATE_CHALLENGE: '/challenge/upsert',
    UPDATE_FILE_CHALLENGE: '/challenge/upload-db-file',
}

export const fetchChallengesAPI = async (
    search: string = "", 
    difficultyLevel: string = "",
    pageNo: number = 0,
    perPage: number = 10,
    tagIds: number[] = []
) => {
    try {
        const params: any = { pageNo, perPage };
        if (search) params.search = search;
        if (difficultyLevel) params.difficultyLevel = difficultyLevel;
        if (tagIds && tagIds.length > 0) params.tagIds = tagIds.join(',');
        
        // console.log("Fetching challenges with params:", params);

        const response = await privateRequest.get(
            ENDPOINT.GET_ALL_CHALLENGES,
            {
                params,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching challenges:', error);
        throw error;
    }
};

export const createChallengesAPI = async (challengeData: any) => {
    try {
        const response = await privateRequest.post(ENDPOINT.CREATE_CHALLENGE, challengeData);
        return response.data;
    }
    catch (error) {
        console.error('Error in upsert challenge:', error);
        throw error;
    }
};

export const updateChallengesByAPI = createChallengesAPI;

export const fetchChallengesByAPI = async (id: string | number) => {
    try {
        const response = await privateRequest.get(`${ENDPOINT.GET_ALL_CHALLENGES}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching challenge by ID:', error);
        throw error;
    }
};

export const uploadFileAPI = async (file: File) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await privateRequest.post(
            ENDPOINT.UPDATE_FILE_CHALLENGE,
            formData
        );

        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};

export const deleteChallengeAPI = async (id: string | number) => {
    try {
        const response = await privateRequest.delete(`${ENDPOINT.GET_ALL_CHALLENGES}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting challenge:', error);
        throw error;
    }
};
